export const CARTDISPLAYED = "CartSlice/displayed";
export const CARTADDED = "CartSlice/added";
export const CARTREMOVED = "CartSlice/removed";
export const CARTUPDATEDINCREMENT = "CartSlice/updatedcounterincrement";
export const CARTUPDATEDDECREMENT = "CartSlice/updatedcounterdecrement";
export const CARTDELETED = "CartSlice/deleted";

export const PLACEORDERADDED    = "CartSlice/placeOrderAdded";
export const ORDERADDED         = "CartSlice/orderAdded";